var VideoEventTracking = /** @class */ (function () {
    function VideoEventTracking() {
        this.progressInterval = 0;
        this.watchedQuarter = false;
        this.watchedHalf = false;
        this.watchedThreeQuarters = false;
        this.watchedFully = false;
    }
    VideoEventTracking.prototype.trigger = function (videoId, videoTitle, action) {
        if (!window.digitalData)
            return;
        var dataObj = {
            category: 'video', // fixed value
            action: action,
            label: videoId, // the Youtube video id
            videoTitle: videoTitle,
        };
        window.digitalData.events = dataObj;
        try {
            window.Bootstrapper.ensEvent.trigger('video');
        }
        catch (err) {
            console.error("Couldn't reach Bootstrapper to trigger 'video' with ".concat(JSON.stringify(dataObj)));
        }
    };
    VideoEventTracking.prototype.stopProgressTracker = function () {
        window.clearInterval(this.progressInterval);
    };
    VideoEventTracking.prototype.clearValues = function () {
        this.watchedQuarter = false;
        this.watchedHalf = false;
        this.watchedFully = false;
        this.watchedFully = false;
    };
    VideoEventTracking.prototype.trackProgress = function (player, duration, videoId, title) {
        var _this = this;
        if (!duration)
            return;
        this.progressInterval = window.setInterval(function () {
            var progress = player.getCurrentTime();
            var percentage = Math.ceil((progress / duration) * 100) / 100;
            if (!_this.watchedQuarter && percentage >= 0.25) {
                _this.trigger(videoId, title, '25');
                _this.watchedQuarter = true;
            }
            if (!_this.watchedHalf && percentage >= 0.5) {
                _this.trigger(videoId, title, '50');
                _this.watchedHalf = true;
            }
            if (!_this.watchedThreeQuarters && percentage >= 0.75) {
                _this.trigger(videoId, title, '75');
                _this.watchedThreeQuarters = true;
            }
            if (!_this.watchedFully && percentage >= 1) {
                _this.trigger(videoId, title, '100');
                _this.watchedFully = true;
                _this.clearValues();
            }
        }, 1000);
    };
    return VideoEventTracking;
}());
export default VideoEventTracking;
